module.exports = __webpack_public_path__ + "static/media/After-You.54fde84c.png";